import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-edit-category',
  templateUrl: './edit-category.component.html',
  styleUrls: ['./edit-category.component.scss']
})
export class EditCategoryComponent implements OnInit {

  submitted = false;
  fileToUpload : any;
  formGroup;
  id;
  formData: any = {};
  imageChanged: boolean = false;

  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private router: Router,
    private toast: ToastClientService,
    private activatedRoute: ActivatedRoute,
  ) { 
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.getCategoryDetails();
  }

  handleFileInput(listOfFiles) {
    let file = listOfFiles[0];

    let reader = new FileReader();
    
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      this.fileToUpload = reader.result;
      this.imageChanged = true;
    }
  }



  back() {
    this.router.navigateByUrl('/hubAdmin/list-category')
  }

  getCategoryDetails() {
    this.apiService.get(this.apiConfig.getAllCategiry + '&id=' + this.id)
      .subscribe((res: any) => {
        this.formData.category_name = res.data.ecommerce_categories.category_name;  
        this.formData.description = res.data.ecommerce_categories.description;  
        this.formData.category_image = res.data.ecommerce_categories.category_image;  
        this.formData.id = res.data.ecommerce_categories.id;
        this.formData.program_id = 1;

        this.fileToUpload = this.formData.category_image
      }, err => {
        console.log(err);
      })
  }

  onSubmitCategory() {

    //check if new image is uploaded
    //only if there is a image change, send image in payload
    //if not, send just the text input values
    if(this.imageChanged == true){
      this.formData.category_image = this.fileToUpload;
      this.imageChanged = false;
    }else{
      delete this.formData.category_image;
    }

    this.apiService.post(this.apiConfig.updateCategory, this.formData)
      .subscribe((res: any) => {
        this.toast.Success('Category editted successfully')
        this.router.navigateByUrl('/hubAdmin/list-category')
      }, err => {
        this.toast.Error('Error editing category');
      })
  }
}
